import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { useGeneralStore } from '@/pinia'
import { useStore } from 'vuex'
import DirectoryNavigation from './DirectoryNavigation.vue'

type Props = {
  title?: string //this prop was added to remove weird hover text in the browser
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FileDirectoryDashboard',
  props: {
    title: {}
  },
  setup(__props: any) {



const piniaStore = useGeneralStore()
const vuexStore = useStore()

const isFeatureFullscreen = computed(() => piniaStore.isFeatureFullscreen)
const mobileScreen = computed(() => vuexStore.state.mobileScreen)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "file-directory-dashboard",
    class: _normalizeClass({
      fullscreen: isFeatureFullscreen.value && !mobileScreen.value,
      mobile: mobileScreen.value
    })
  }, [
    _createVNode(DirectoryNavigation, {
      fullscreen: isFeatureFullscreen.value,
      "show-search": "",
      "show-breadcrumbs": "",
      "show-toolbar": "",
      "drag-drop-enabled": "",
      "multi-select-enabled": ""
    }, null, 8, ["fullscreen"])
  ], 2))
}
}

})